import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setHomepageCategory } from "redux/actions/homepageCategoriesActions";

import { SEARCH_API_DELIMITER } from "../../constants/generalConstants";
import { PRODUCT_RESULTS } from "../../constants/routes";
import { homepageSmartFormBoxL4SX } from "../../styled/styledSXProperties/styledBoxSX";
import {
    homepageSmartFormCardL4SX,
    homepageSmartFormCardMobileL4SX,
} from "../../styled/styledSXProperties/styledCardSX";
import { homepageIconDispatcher } from "./homePageIcon";

const L4HomePageCard = ({ team, data, name, isDesktop }) => {
    const categoryIds = data[name];
    // Local states
    const [searchQuery, setSearchQuery] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        const searchParams = new URLSearchParams();
        categoryIds
            ? searchParams.set(
                  "category",
                  categoryIds.join(SEARCH_API_DELIMITER)
              )
            : searchParams.delete("category");
        setSearchQuery("?" + searchParams);
    }, [categoryIds]);

    const selectIcon = () => {
        const matchedKey = Object.keys(homepageIconDispatcher).find((key) =>
            team.toLowerCase().includes(key)
        );
        return matchedKey
            ? homepageIconDispatcher[matchedKey]
            : homepageIconDispatcher["default"];
    };

    const darkMode = useSelector((state) => state.general.darkMode);

    const resetCategories = () => {
        dispatch(setHomepageCategory([null, null, null]));
    };

    return (
        <Link
            to={PRODUCT_RESULTS + searchQuery}
            style={{ textDecoration: "none" }}
            onClick={() => resetCategories()}
        >
            <Card
                sx={
                    isDesktop
                        ? homepageSmartFormCardL4SX(darkMode)
                        : homepageSmartFormCardMobileL4SX(darkMode)
                }
            >
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Box sx={homepageSmartFormBoxL4SX(darkMode)}>
                            {selectIcon()()}
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            variant="body2"
                            fontWeight="normal"
                            align="right"
                            color="text.secondary"
                        >
                            PSG Codes
                        </Typography>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            align="right"
                        >
                            {categoryIds ? categoryIds.length : 0}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" fontWeight="light">
                            {name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            size="small"
                            color="secondary"
                            endIcon={<ArrowForwardIcon />}
                            style={{ fontSize: "12px" }}
                        >
                            Browse Items
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </Link>
    );
};

export default L4HomePageCard;
